var $108b6fa1207dedf4$exports = {};
//change Color menu from white to black on hero section
//data
const $108b6fa1207dedf4$var$header = document.querySelector('header.c-header');
const $108b6fa1207dedf4$var$headerContact = document.querySelector(".c-header__contact");
const $108b6fa1207dedf4$var$headerContactCTA = document.querySelector(".c-header__contact--cta");
const $108b6fa1207dedf4$var$hamburgerMenu = document.querySelector(".c-header__hamburger__lines");
const $108b6fa1207dedf4$var$sectionToChange = document.querySelector(".changeMenuColor");
const $108b6fa1207dedf4$var$logo = document.querySelector(".c-main-logo");
//set header to black when page loaded
$108b6fa1207dedf4$var$headerContact.classList.add("color-black");
$108b6fa1207dedf4$var$header.classList.add('header--dark');
if ($108b6fa1207dedf4$var$headerContactCTA.classList.contains('reverse')) $108b6fa1207dedf4$var$headerContactCTA.classList.add("border-black--reverse");
else $108b6fa1207dedf4$var$headerContactCTA.classList.add("border-black");
$108b6fa1207dedf4$var$hamburgerMenu.classList.add("background-black");
$108b6fa1207dedf4$var$logo.classList.add("c-main-logo--dark");
//function on scroll whitch looking for scroll to 2 section
document.addEventListener("scroll", ()=>{
    if (document.documentElement.scrollTop > 0) {
        $108b6fa1207dedf4$var$headerContact.classList.remove("color-black");
        $108b6fa1207dedf4$var$headerContactCTA.classList.remove("border-black");
        if ($108b6fa1207dedf4$var$headerContactCTA.classList.contains('reverse')) $108b6fa1207dedf4$var$headerContactCTA.classList.remove("border-black--reverse");
        else $108b6fa1207dedf4$var$headerContactCTA.classList.remove("border-black");
        $108b6fa1207dedf4$var$hamburgerMenu.classList.remove("background-black");
        $108b6fa1207dedf4$var$logo.classList.remove("c-main-logo--dark");
    } else {
        $108b6fa1207dedf4$var$headerContact.classList.add("color-black");
        if ($108b6fa1207dedf4$var$headerContactCTA.classList.contains('reverse')) $108b6fa1207dedf4$var$headerContactCTA.classList.add("border-black--reverse");
        else $108b6fa1207dedf4$var$headerContactCTA.classList.add("border-black");
        $108b6fa1207dedf4$var$hamburgerMenu.classList.add("background-black");
        $108b6fa1207dedf4$var$logo.classList.add("c-main-logo--dark");
    }
});


//# sourceMappingURL=uncommon.a3fdbe94.js.map
